<template>
  <div id="support_input">
    <dd-header />
    <h2 class="hakotan_title">お問い合わせ</h2>
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <section class="support_section">
            <h1 class="support_text">フォームでのお問い合わせ</h1>
            <ul class="ul_input_support">
              <li>
                <div class="supprt_item">
                  <span class="support_label">{{label.supportTitle}}</span>
                  <span class="important hakoten_small_text">必須</span>
                </div>
                <div v-for="support in supportList" :key="support.id">
                  <div class="supprt_item">
                    <label class="option_check">
                      <input type="checkbox" :id="'support.id'" v-model="checkList" :value="support.name" />
                      <span class="opt_check"></span>
                      <span class="opt_label">{{support.name}}</span>
                    </label>
                  </div>
                </div>
                <div v-if="errors.supportTitle" class="error_text">{{errors.supportTitle}}</div>
              </li>
              <li>
                <div>
                  <span class="support_label">{{label.supportBody}}</span>
                  <span class="important hakoten_small_text">必須</span>
                </div>
                <textarea v-model="support.supportBody" cols="100" rows="5" maxlength="256" class="support_msg_area"/>
                <div v-if="errors.supportBody" class="error_text">{{errors.supportBody}}</div>
              </li>
              <li>
                <div>
                  <span class="support_label">{{label.userName}}</span>
                  <span class="important hakoten_small_text">必須</span>
                </div>
                <div class="supprt_input_text">
                  <input type="text" v-model.trim="support.userLastName" placeholder="家具" maxlength="32" class="support_sp"/>
                  <input type="text" v-model.trim="support.userFirstName" placeholder="太郎" maxlength="32"/>
                </div>
                <div v-if="errors.userName" class="error_text">{{errors.userName}}</div>
              </li>
              <li>
                <div>
                  <span class="support_label">{{label.userNameKana}}</span>
                  <span class="important hakoten_small_text">必須</span>
                </div>
                <div class="supprt_input_text">
                  <input type="text" v-model.trim="support.userLastNameKana" placeholder="カグ" maxlength="32"  class="support_sp"/>
                  <input type="text" v-model.trim="support.userFirstNameKana" placeholder="タロウ" maxlength="32"/>
                </div>
                <div v-if="errors.userNameKana" class="error_text">{{errors.userNameKana}}</div>
              </li>
              <li>
                <div>
                  <span class="support_label">{{label.tel}}</span>
                  <span class="important hakoten_small_text">必須</span>
                </div>
                <input type="text" v-model.trim="support.tel" @keypress="validateNumber" @input="support.tel=inputRestNumber($event)" oninput="if(value.length>11)value=value.slice(0,11)" maxlength="11" class="support_msg_area"/>
                <div v-if="errors.tel" class="error_text">{{errors.tel}}</div>
              </li>
              <li>
                <div>
                  <span class="support_label">{{label.email}}</span>
                  <span class="important hakoten_small_text">必須</span>
                </div>
                <input type="text" v-model.trim="support.email" maxlength="256" class="support_msg_area"/>
                <div v-if="errors.email" class="error_text">{{errors.email}}</div>
              </li>
            </ul>
            <div class="btn_pos_center btn_color support_btn" @click="cofirm()">内容確認</div>
          </section>
          <section class="support_section">
            <div class="support_text">お電話でのお問い合わせ</div>
            <div class="support_msg">
              <div>
                まずはお気軽にお問い合わせください。
              </div>
              <div>
                TEL 0575-62-2311
              </div>
              <div>
                月〜金曜日（10:00〜17:00）、定休日：土日祝
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import * as App from '../../utils/App'
import * as FormUtil from '../../utils/FormUtil'
import * as Check from '../../utils/Check'
import {DC_STORAGE_KEY} from '../../constants/App'
// Module
import DcHeader from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'

export default {
  name: 'SupportInput',
  components: {
    'dd-header': DcHeader,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu
  },
  data () {
    return {
      pageKey: 'supportInput',
      supportList: [
        {id: 1, name: '商品について'},
        {id: 2, name: 'ご注文方法について'},
        {id: 3, name: '面材について'},
        {id: 4, name: '組立設置サービスについて'},
        {id: 5, name: '注文した商品について'},
        {id: 6, name: 'その他'}
      ],
      checkList: [],
      support: {
        supportTitle: [],
        supportBody: '',
        userLastName: '',
        userFirstName: '',
        userLastNameKana: '',
        userFirstNameKana: '',
        tel: '',
        email: ''
      },
      errors: {},
      label: {
        supportTitle: 'お問い合わせ内容',
        supportBody: 'メッセージ',
        userName: '氏名',
        userNameKana: '氏名（カナ）',
        tel: '電話番号（半角、ハイフンなし）',
        email: 'メールアドレス'
      }
    }
  },
  computed: {
  },
  methods: {
    cofirm: function () {
      // エラーメッセージのクリア
      this.errors = {}

      // 入力チェック
      this.validateRequire()
      if (Object.keys(this.errors).length !== 0) {
        return
      }
      this.validateFormat()
      if (Object.keys(this.errors).length !== 0) {
        return
      }
      this.support.supportTitle = this.checkList

      App.setLocalStorage(DC_STORAGE_KEY.SUPPORT_DATA, this.support)

      this.$router.push({
        name: 'SupportConfirm',
        params: {
          supportData: this.support
        }
      })
    },
    cancel: function () {
      this.$router.go(-1)
    },
    validateRequire: function () {
      if (this.checkList.length === 0) this.errors['supportTitle'] = this.label.supportTitle + 'は必須項目です。'
      if (!this.support.supportBody) this.errors['supportBody'] = this.label.supportBody + 'は必須項目です。'
      if (!this.support.userLastName || !this.support.userFirstName) this.errors['userName'] = this.label.userName + 'は必須項目です。'
      if (!this.support.userLastNameKana || !this.support.userFirstNameKana) this.errors['userNameKana'] = this.label.userNameKana + 'は必須項目です。'
      if (!this.support.tel) this.errors['tel'] = this.label.tel + 'は必須項目です。'
      if (!this.support.email) this.errors['email'] = this.label.email + 'は必須項目です。'
    },
    validateFormat: function () {
      if (!Check.isKana(this.support.userLastNameKana) || !Check.isKana(this.support.userFirstNameKana)) {
        this.errors['userNameKana'] = this.label.userNameKana + 'はカタカナで入力してください。'
      }
      if (!Check.isTel(this.support.tel)) this.errors['tel'] = '電話番号は半角数値かつ、10～11文字で入力してください。'
      if (!Check.isMail(this.support.email)) this.errors['email'] = 'メールアドレスの形式ではありません。'
    },
    fetchData: function () {
      let lform = App.getLocalStorage(DC_STORAGE_KEY.SUPPORT_DATA)
      if (lform) {
        this.support = lform
      }
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      if (str.length <= 0) {
        return ''
      }
      return str
    }
  },
  created () {
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>
<style src="../css/dc-common.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcSupportInput.vue